import { RootState } from '../index';

export const getUserStudies = (state: RootState) => state.user.studies;
export const getAllUser = (state: RootState) => state.user.users;
export const userLoading = (state: RootState) => state.user.isLoading;
export const userError = (state: RootState) => state.user.error;
